<template>
  <div id="task-detail">
    <section class="content">
      <p class="title-second">
        需求发布流程
      </p>
      <process />
      <section class="mt-10">
        <publish-from :form="form" modal="view" :change-time="showBtn.republish" />
      </section>
    </section>
    
    <section class="mt-20 content clearfix">
      <p class="title-second">
        报名信息
      </p>
      <div>
        <ux-table v-if="signatureSign !== '1'" v-model="tableData" :columns="columns" :row-selection="rowSelection" />
        <ux-table v-else v-model="tableData" :columns="columns" />
      </div>
      <div v-if="signatureSign === '1'" class="mt-20">
        <p class="title-second">
          方案评分
        </p>
        <ux-table v-model="scoreResult" :columns="scoreResColumns" :row-selection="rowSelection" />
      </div>
      

      <div class="mt-20 operation float-right">
        <ux-button v-if="showBtn.ing" class="ml-10" type="primary">
          报名中
        </ux-button>
        <ux-button v-if="showBtn.republish" class="ml-10" type="primary" @click="republish">
          修改截止时间，重新发布
        </ux-button>
        <ux-button v-if="showBtn.score" class="ml-10" type="primary" @click="startScore">
          发起评分
        </ux-button>
        <ux-button v-if="showBtn.selecting" class="ml-10" type="primary">
          比选中
        </ux-button>
        <ux-button v-if="showBtn.done" class="ml-10" type="primary">
          已完成
        </ux-button>
        <ux-button v-if="showBtn.confirm" class="ml-10" type="primary" @click="confirm">
          确认选择
        </ux-button>
        <ux-button v-if="showBtn.cancel" class="ml-10" type="danger" @click="cancelRequire">
          取消需求
        </ux-button>
        <ux-button v-if="showBtn.canceled" class="ml-10" type="danger">
          已取消
        </ux-button>
      </div>
    </section>

    <section>
      <ux-modal v-model="selectFwsVisible" title="提示">
        <div>是否确认选择该服务商（<span v-if="rowSelection.selectedFws" style="color: #4285F4">{{ rowSelection.selectedFws.isvName }}</span>）作为中标方</div>
        <div slot="footer">
          <ux-button type="success" @click="confirmFws">
            确认
          </ux-button>
          <ux-button @click="cancelFws">
            取消
          </ux-button>
        </div>
      </ux-modal>

      <ux-modal v-model="scoreVisible" title="提示">
        <div>即将发起需求评分流程，将有如下人员进行方案评审，请相关人员关注服务市场豆芽公众号内通知消息，并及时处理，否则将影响需求交付时间；</div>
        <ux-table v-model="scoreData" class="mt-10" :columns="scoreColumns" />
        <div slot="footer">
          <ux-button type="success" @click="confirmScore">
            确认
          </ux-button>
          <ux-button @click="cancelScore">
            取消
          </ux-button>
        </div>
      </ux-modal>

      <ux-modal v-model="scoreDetailVisible" title="审批意见" width="700px">
        <ux-table v-model="scoreDetailData" class="mt-10" :columns="scoreDetailColumns" />
        <div slot="footer">
          <ux-button type="success" @click="confirmScoreDetail">
            确认
          </ux-button>
        </div>
      </ux-modal>

      <ux-modal v-model="cancelVislable">
        <div slot="title">
          温馨提示
        </div>
        <div class="content">
          <span>
            <img src="../assets/info.png" alt="">
          </span>
          <span class="ml-10">是否确认取消该需求？</span>
        </div>
        <div slot="footer">
          <ux-button type="success" @click="confirmCancel">
            确定
          </ux-button>
          <ux-button @click="cancelC">
            取消
          </ux-button>
        </div>
      </ux-modal>
    </section>
  </div>
</template>

<script>
import UxMessage from '@cloud-sn/uxcool/es/message';
import process from './component/process';
import {squareService} from '../service';
import publishFrom from './component/publish_form';
import { getCols, getScoreCols, getScoreResCols, getScoreDetailCols } from './table_config';
import { operatStatus } from './component/config';

export default {
  components: {
    process,
    publishFrom
  },
  data() {
    return {
      form: {

      },
      tableData:[],
      showBtn: {
        ing: false, //报名中
        cancel: false, //取消需求
        canceled: false, // 已取消
        confirm: false, // 确认选择
        score: false, // 发起评分
        republish: false, // 修改截至时间，重新发布
        selecting: false, // 比选中
        done: false, // 已完成
        // ing: true, //报名中
        // cancel: true, //取消需求
        // canceled: true, // 已取消
        // confirm: true, // 确认选择
        // score: true, // 发起评分
        // republish: true, // 修改截至时间，重新发布
        // selecting: true, // 比选中
        // done: true, // 已完成
      },
      selectFwsVisible: false,
      selectedFws:{},
      rowSelection: {
        selectedRowKeys: [],
        type: 'radio',
        columnWidth: 10,
        columnTitle: 'xasaxs',
        onChange(selectedRowKeys, selectedRow, op, prevSelectRowKeys) {
          this.selectedFws = selectedRow[0];
        },
      },
      scoreVisible: false,
      scoreData: [],
      cancelVislable: false,
      signatureSign: '',
      scoreResColumns: [],
      scoreResult: [],
      scoreDetailVisible: false,
      scoreDetailData: [],
      scoreDetailColumns: []
    }
  },
  created() {
    this.customizedCode = this.$route.query.customizedCode;
    this.getDemandDetail();
    this.columns = getCols.call(this);
    this.scoreColumns = getScoreCols.call(this);
    this.scoreResColumns = getScoreResCols.call(this);
    this.scoreDetailColumns = getScoreDetailCols.call(this);
    // operatStatus({state: '11'})
  },
  methods: {
    cancelC() {
      this.cancelVislable = false;
    },
    confirmCancel() {
      const params = {
        customizedCode: this.form.customizedCode,
        // traceStatus: this.form.traceStatus,
      }
      squareService.cancelRequire(params).then(() => {
        this.cancelVislable = false;
        UxMessage.success('取消需求成功');
        this.operationSuccess();
      }, (errMsg) => {
        UxMessage.error(errMsg);
      })
    },
    startScore() {
      const params = {
        customizedCode: this.form.customizedCode,
        signatureType: '1'
      }
      squareService.getScoreRole(params).then((roles) => {
        this.scoreData = roles || [];
        this.scoreVisible = true;
      }, (errMsg) => {
        UxMessage.error(errMsg)
        this.scoreVisible = true;
      })
    },
    formatAuditNos(scoreData) {
      const temp = [];
      scoreData.forEach((item) => {
        temp.push(item.reviewerId)
      })
      return temp;
    },
    confirmScore() {
      const {customizedCode, signatureSign, traceStatus} = this.form;
      const params = {
        customizedCode,
        signatureType: '1',
        auditNos: this.formatAuditNos(this.scoreData).join(','),
      }
      squareService.operateTaskSignature(params).then(() => {
        UxMessage.success('发起评分成功');
        this.operationSuccess();
      }, () => {
        UxMessage.error('发起评分失败');
      })
    },
    cancelScore() {
      this.scoreVisible = false;
    },
    operationSuccess(){
      // this.selectFwsVisible = false;
      // this.$router.push({name: 'square'})
      this.gotoMyCustom();
    },
    republish() {
      const params = {
        customizedCode: this.form.customizedCode,
        deadlineDate: typeof this.form.deadlineDate === 'string' ?  this.form.deadlineDate : this.form.deadlineDate.Format('yyyy-MM-dd'),
        // traceStatus: this.form.traceStatus,
      }
      squareService.republish(params).then((res) => {
        UxMessage.success('重新发布成功');
        this.operationSuccess();
      }, (errMsg) => {
        UxMessage.error(errMsg);
      })
    },
    confirm() {
      if(!this.rowSelection.selectedFws) {
        UxMessage.warn('请选择一个服务商作为中标方');
        return;
      }
      this.selectFwsVisible = true;
    },
    confirmFws() {
      const params = {
        customizedCode: this.form.customizedCode,
        isvMemberNo: this.rowSelection.selectedFws.isvMemberNo,
        // traceStatus: this.form.traceStatus,
      }
      squareService.selectProvider(params).then((res) => {
        UxMessage.success('选择成功');
        this.selectFwsVisible = false;
        // this.$router.push({name: 'square'});
        this.gotoMyCustom();
      }, (errMsg) => {
        UxMessage.error(errMsg);
      })
    },
    gotoMyCustom() {
      console.log('go')
      window.location.href = '/fuwu/home/myCustom.action';
    },
    cancelFws() {
      this.selectFwsVisible = false;
    },
    getDemandDetail() {
      const params = {
        customizedCode: this.customizedCode,
        type: 'fuwu'
      }
      squareService.getTaskDetail(params).then((detail) => {
        const {isvNameList, isvDetailList, isvEnterNameOutputsList, isvScoreOutputList, ...baseInfo} = detail;
        const {traceStatus, accountType, signatureSign, maxBudget, alreadyApplyNumber} = baseInfo;
        this.form = baseInfo;
        this.signatureSign = signatureSign;
        this.tableData = isvEnterNameOutputsList;
        this.scoreResult = isvScoreOutputList;
        this.showBtn = operatStatus({state: traceStatus, accountType, signatureSign, maxBudget, alreadyApplyNumber})
      })
    },
    cancelRequire() {
      this.cancelVislable = true;
    },
    download(url) {
      window.open(url, '_blank');
    },
    viewScoreDetail(row) {
      const params = {
        customizedCode: this.customizedCode,
        isvMemberNo: row.isvMemberNo
      }
      squareService.getScroeDetail(params).then((res) => {
        this.scoreDetailData = res;
        this.scoreDetailVisible = true;
      }, (errMsg) => {
        UxMessage.error(errMsg);
      })
    },
    confirmScoreDetail() {
      this.scoreDetailVisible = false;
    }
  }
}
</script>
<style scope>
/* #task-detail {
  padding: 20px;
} */
.content {
  background: #ffffff;
  padding: 10px 20px;
}
.ux-btn-danger {
  color: #fff !important;
  background-color: #ff4d4f !important;
  border-color: #ff4d4f !important;
}
</style>